import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
axios.defaults.withCredentials = true
import VueAxios from 'vue-axios'
import VueSessionStorage from 'vue-sessionstorage'
import APIService from './services/api'
import AsyncComputed from 'vue-async-computed'
import VueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'
import i18n from '@/plugins/i18n'
import { dateToISO } from './helpers/filters'
import Nl2BrDirective from './directives/Nl2BrDirective'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
VueClipboard.config.autoSetContainer = true;

Vue.use(VueAxios, axios)
Vue.use(VueSessionStorage)
Vue.use(AsyncComputed)
Vue.use(VueMoment)
Vue.use(VueClipboard)

Vue.filter('dateToISO', dateToISO)
Vue.directive('nl2br', Nl2BrDirective)

Vue.prototype.$api = new APIService();
Vue.prototype.$eventBus = new Vue() // global Event Bus

const appEl = document.querySelector('#app');

new Vue({
  vuetify,
  router,
  store,
  i18n,
  // render: h => h(App),
  render: createElement => {
    const context = {
      props: { ...appEl.dataset },
    };
    return createElement(App, context);
  },
}).$mount('#app')

Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}

String.prototype.capitalize = function() {
  return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
}
